import { createSlice } from '@reduxjs/toolkit';
import { TAG_DISPLAY_LIMIT } from 'pages/Tags/TagConstants';
import { TagsState } from 'types/tag/TagTypes';

const initialState: TagsState = {
  TagModal: {
    activeTagIndex: null,
    EditKey: null,
    tagModalOpen: false,
    TagValues: {
      name: '',
      type: 'items',
      description: '',
      color: '#4bb189',
      active: '1',
    },
    countSubmit: 0,
    showAllValidateErrors: false,
    FormErrorCount: 1,
    isEdit: false,
  },
  PageFilters: {
    tagName: '',
  },

  PageDetails: {
    entriesPerPage: TAG_DISPLAY_LIMIT,
    currentPage: 0,
    inputPageValue: 1,
  },
};

const tagsSlice = createSlice({
  name: 'Tags',
  initialState,
  reducers: {
    setActiveTagIndex: (state, action) => {
      state.TagModal.activeTagIndex = action.payload;
    },
    setTagModalOpen: (state, action) => {
      state.TagModal.tagModalOpen = action.payload;
    },
    setTagValues: (state, action) => {
      state.TagModal.TagValues = action.payload;
    },
    setShowAllValidateTagErrors: (state, action) => {
      state.TagModal.showAllValidateErrors = action.payload;
    },
    setCountTagSubmit: (state) => {
      state.TagModal.countSubmit += 1;
    },
    setTagFormErrorCount: (state, action) => {
      state.TagModal.FormErrorCount = action.payload;
    },
    setTagEditKey: (state, action) => {
      state.TagModal.EditKey = action.payload;
    },
    setIsEditTag: (state, action) => {
      state.TagModal.isEdit = action.payload;
    },
    resetTagForm: (state) => {
      state.TagModal = {
        ...state.TagModal,
        activeTagIndex: null,
        EditKey: null,
        TagValues: {
          name: '',
          type: 'items',
          description: '',
          color: '#4bb189',
          active: '1',
        },
        countSubmit: 0,
        showAllValidateErrors: false,
        FormErrorCount: 1,
        isEdit: false,
      };
    },
    setPageFilters(state, action) {
      state.PageFilters = action.payload;
    },
    setEntriesPerPage(state, action) {
      state.PageDetails.entriesPerPage = action.payload;
    },
    setCurrentPage(state, action) {
      state.PageDetails.currentPage = action.payload;
    },
    setInputPageValue(state, action) {
      state.PageDetails.inputPageValue = action.payload;
    },
  },
});

export const {
  setActiveTagIndex,
  setTagModalOpen,
  setTagValues,
  setShowAllValidateTagErrors,
  setCountTagSubmit,
  setTagFormErrorCount,
  setTagEditKey,
  setIsEditTag,
  resetTagForm,
  setPageFilters,
  setEntriesPerPage,
  setCurrentPage,
  setInputPageValue,
} = tagsSlice.actions;

export default tagsSlice.reducer;
